// eslint-disable-next-line simple-import-sort/imports
import { DatesSetArg, EventContentArg } from "@fullcalendar/core"; // must go before plugins
import itLocale from "@fullcalendar/core/locales/it";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import {
  Day,
  RoleType,
  UsersPermissionsUser,
  combineDateAndTime,
  createOrGetDayOnCompleted,
  getDayFromListByDate,
  getFirstItem,
  getStartEndOfMonth,
  selectedDayAtom,
  useCreateOrGetQuery,
  useGetDaysByUserQuery,
  useGetUsersQuery,
  workedHours
} from "@mc-intranet/shared";
import { Close, LogoutOutlined } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import exportFromJSON from "export-from-json";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import moment from "moment";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  authStorageAtom,
  daysByUserQueryVariablesSelector,
  holydaysByYearsAtom
} from "../../atoms";
import { useGraphQLClient } from "../../cache";
import CalendarWrapper from "../../components/Calendar";
import PresenceCell from "../../components/Calendar/Cells/Presence";
import EditDayView from "../../components/days/EditDayView";
import {
  correctPuncesColor,
  hoursOffColor,
  isSickColor,
  missingPuncesColor,
  vacationColor
} from "../../theme";

const userOnVacations: { title: string; color: string }[] = [
  {
    title: "Timbratura corretta",
    color: correctPuncesColor
  },
  {
    title: "Timbratura incompleta",
    color: missingPuncesColor
  },
  {
    title: "Ferie",
    color: vacationColor
  },
  {
    title: "Permessi",
    color: hoursOffColor
  },
  {
    title: "In Malattia",
    color: isSickColor
  }
];

const PresenzePage = () => {
  const authStorage = useAtomValue(authStorageAtom);
  const { user, role } = authStorage;

  const canSeeOtherUsers = role === RoleType.account || role === RoleType.admin;

  const [selectedUser, setSelectedUser] = useState(user);
  const [createOrGetVariables, setCreateOrGetVariables] = useState<
    { user: string; date: string } | undefined
  >();
  const [selectedMonth, setSelectedMonth] = useState(moment());
  const setDay = useSetAtom(selectedDayAtom);

  const [currentDay, setCurrentDay] = useState<string>();
  const [modalVisible, setModalVisible] = useState(false);
  const [holidays, setHolidays] = useAtom(holydaysByYearsAtom);
  const [calData, setCalData] = useState<any[]>(Object.values(holidays).flat());
  const [variables, setVariables] = useAtom(daysByUserQueryVariablesSelector);
  // console.log("selectedUser :>> ", selectedUser);
  const { client } = useGraphQLClient();
  const queryClient = useQueryClient();

  const { data: usersData, isLoading: usersLoading } = useGetUsersQuery(
    client,
    {},
    {
      enabled: !!user && canSeeOtherUsers,
      onError: (error: any) => {
        toast.error(error?.response?.error.message, {
          position: toast.POSITION.TOP_CENTER
        });
      }
    }
  );
  // console.log("variables :>> ", variables);
  const { data: daysData, isLoading: loadingDays } = useGetDaysByUserQuery(
    client,
    variables,
    {
      enabled: !!user && !!variables,
      onError: (error: any) => {
        toast.error(error?.response?.error.message, {
          position: toast.POSITION.TOP_CENTER
        });
      }
    }
  );

  useCreateOrGetQuery(client, createOrGetVariables as any, {
    enabled: !!createOrGetVariables,
    onSuccess: (data) => {
      if (currentDay) {
        createOrGetDayOnCompleted({
          data,
          queryClient,
          variables
        });
        setCurrentDay(undefined);
        const _day = data?.createOrGet?.data as Day;
        console.log("_day :>> ", _day);
        setDay(_day);

        setModalVisible(true);
      }
    },
    onError: (error: any) => {
      toast.error(error?.response?.error.message, {
        position: toast.POSITION.TOP_CENTER
      });
    }
  });

  const onSelectDate = (arg: DateClickArg) => {
    const date = moment(arg.dateStr);
    const day = getDayFromListByDate(
      date,
      daysData?.days as Day[]
    ) as Day;
    console.log("day", day);
    // console.log("changingMonth ", changingMonth);

    setCurrentDay(date.format("YYYY-MM-DD"));

    if (day) {
      setDay(day);
      setModalVisible(true);
    } else {
      setCreateOrGetVariables({
        user: selectedUser?.documentId as string,
        date: date.format("YYYY-MM-DD")
      });
    }
  };

  const handleUserChange = (
    event: React.SyntheticEvent<Element, Event>,
    value: UsersPermissionsUser
  ) => {
    // console.log(`event`, event);
    console.log(`value`, value);
    setSelectedUser(value);
    const newValue = {
      ...variables,
      userId: value?.documentId as string
    };
    setVariables(newValue);
  };

  useEffect(() => {
    if (daysData) {
      const days = daysData.days?.map((day) => {
        // EventSourceInput;
        return {
          id: day?.documentId,
          start: day?.date,
          extendedProps: day as Day,
          backgroundColor: "transparent",
          borderColor: "transparent"
          // disably: "background"
        };
      });
      // console.log("holidays :>> ", holidays);
      // console.log("days :>> ", days);
      setCalData([...Object.values(holidays).flat(), ...(days as any[])]);
    }
  }, [daysData, holidays]);

  // console.log("daysData :>> ", daysData);
  // console.log("calData :>> ", calData);

  const renderEventContent = (eventContent: EventContentArg) => {
    const { event } = eventContent;
    const { display, extendedProps } = event;
    const item = extendedProps as Day;

    const isEmpty =
      getFirstItem(item?.hoursOff) === undefined &&
      !item?.isSick &&
      getFirstItem(item?.punches) === undefined &&
      !item?.vacation;

    if (display === "background" && isEmpty) return;
    // console.log(`eventContent`, eventContent.event);
    return <PresenceCell user={selectedUser} eventContent={eventContent} />;
  };

  const dateChange = (arg: DatesSetArg) => {
    // console.log("datesSet", arg);
    //aggiorno il mese selezionato prendo 10 giorni dal primo giorno per evitare che si veda il mese precedente
    const startOfMonth = moment(arg.start).add(10, "d");
    setSelectedMonth(startOfMonth);
    // aggiorno le vacanze se cambia l'anno
    const start = moment(arg.start).year();
    const end = moment(arg.end).year();
    const isOverlapping = start !== end;
    if (isOverlapping) {
      // console.log("set isOverlapping");
      setHolidays([start, end]);
    } else {
      // console.log("set year");
      setHolidays(end);
    }

    setVariables({
      userId: selectedUser?.documentId as string,
      startDate: moment(arg.start).format("YYYY-MM-DD"),
      endDate: moment(arg.end).format("YYYY-MM-DD")
    });
  };

  const exportFile = () => {
    const { startOfMonth, endOfMonth } = getStartEndOfMonth(selectedMonth);

    const exportedUser = canSeeOtherUsers
      ? usersData?.usersPermissionsUsers?.find(
          (u) => u?.documentId === selectedUser?.documentId
        )
      : user;
    const isPartTime = !!exportedUser?.isPartTime;

    const calendar: any = {};

    for (
      let current = startOfMonth;
      current <= endOfMonth;
      current.add(1, "d")
    ) {
      calendar[current.format("YYYY-MM-DD")] = {
        Giorno: current.format("ddd"),
        Data: current.format("DD/MM/YYYY"),
        IN: "-",
        OUT: "-",
        Location: "-",
        Ore: 0,
        Minuti: 0,
        Ferie: "-",
        Permessi: "-",
        Malattia: "-"
      };
    }

    const days = daysData?.days as Day[];
    days.forEach((day) => {
      const { date, punches, vacation, totalHoursOff, isSick } =
        day as Day;

      const { ore, minuti } = workedHours(day);

      if (calendar[date]) {
        let punchIn = "";
        let punchOut = "";
        let location = "";
        punches?.forEach((punch) => {
          punchIn += `${
            combineDateAndTime(date, punch?.in, "HH:mm") || "-"
          }<br/>`;
          punchOut += `${
            combineDateAndTime(date, punch?.out, "HH:mm") || "-"
          }<br/>`;
          location += `${punch?.location || "-"}<br/>`;
        });

        // arrotondo minuti per step di 15
        let minutiRounded = Math.round(minuti / 15) * 15;
        let oreRounded = minutiRounded === 60 ? ore + 1 : ore;

        if (minutiRounded === 60) {
          minutiRounded = 0;
        }

        // 7:45 e 8:15 vengono esportate come 8 ore piene (non per i part time)
        if (
          !isPartTime &&
          ((oreRounded === 7 && minutiRounded === 45) ||
            (oreRounded === 8 && minutiRounded === 15))
        ) {
          oreRounded = 8;
          minutiRounded = 0;
        }

        // const _ore = `${oreRounded} ore${
        //   minutiRounded === 0 ? "" : " " + minutiRounded + " min"
        // }`;
        // const _ore = `${oreRounded} ore${
        //   minutiRounded === 0 ? "" : " " + minutiRounded + " min"
        // }`;

        calendar[date] = {
          ...calendar[date],
          IN: punchIn === "" ? "-" : punchIn,
          OUT: punchOut === "" ? "-" : punchOut,
          Location: location === "" ? "-" : location,
          Ore: oreRounded,
          Minuti: minutiRounded,
          Ferie: vacation ? "SI" : "-",
          Permessi: (totalHoursOff ?? 0) > 0 ? totalHoursOff : "-",
          Malattia: isSick ? "SI" : "-"
        };
      }
    });

    console.log("calendar ", Object.values(calendar));

    const lastName = exportedUser?.lastName ?? "";

    const data = Object.values(calendar);
    const fileName = `${lastName}-${selectedMonth.format("MM-YYYY")}`;
    const exportType = "xls";

    exportFromJSON({ data, fileName, exportType });
  };

  return (
    <Box pb={3}>
      <Box
        className="switch-user"
        display="flex"
        alignItems="center"
        justifyContent="center"
        paddingY={3}
      >
        {canSeeOtherUsers && usersData ? (
          <>
            <span>Cambia utente</span>
            {!usersLoading &&
              getFirstItem(usersData?.usersPermissionsUsers) && (
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  sx={{
                    bgcolor: "background.default",
                    marginInline: 2,
                    width: 200
                  }}
                  size="small"
                  disableClearable={true}
                  value={selectedUser as UsersPermissionsUser}
                  options={
                    (usersData?.usersPermissionsUsers as UsersPermissionsUser[]) ??
                    []
                  }
                  getOptionLabel={(option) =>
                    `${option?.firstName} ${option?.lastName}`
                  }
                  isOptionEqualToValue={(option, value) => {
                    return option.documentId === value.documentId;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Utente"
                      placeholder="Utente"
                    />
                  )}
                  onChange={handleUserChange}
                />
              )}
          </>
        ) : (
          <Typography
            marginRight={2}
          >{`${user?.firstName} ${user?.lastName}`}</Typography>
        )}

        <Button
          className="export"
          variant="outlined"
          endIcon={<LogoutOutlined />}
          onClick={exportFile}
          sx={{
            bgcolor: "background.default"
          }}
        >
          Excel
        </Button>
      </Box>

      <CalendarWrapper isLoading={loadingDays}>
        <FullCalendar
          plugins={[dayGridPlugin, interactionPlugin]}
          locale={itLocale}
          initialView="dayGridMonth"
          events={calData}
          eventContent={renderEventContent}
          datesSet={dateChange}
          dateClick={onSelectDate}
          // eventClick={eventClick}
          headerToolbar={{
            start: "title",
            center: "",
            end: "today prevYear,prev,next,nextYear"
          }}
        />
      </CalendarWrapper>

      <Stack direction={{ xs: "column", md: "row" }} spacing={2} mt={2}>
        {userOnVacations.map((item) => {
          const { color, title } = item;
          return (
            <Stack key={color} direction="row" spacing={2} alignItems="center">
              <Box
                bgcolor={color}
                borderRadius="50%"
                mb="3px"
                height="10px"
                width="10px"
              />
              <Typography>{title}</Typography>
            </Stack>
          );
        })}
      </Stack>

      {modalVisible && (
        <Dialog
          open={modalVisible}
          onBackdropClick={() => setModalVisible(false)}
          sx={{ ".MuiPaper-root": { borderRadius: 2 } }}
        >
          <DialogTitle sx={{ m: 0, p: 0 }}>
            <IconButton
              aria-label="close"
              onClick={() => setModalVisible(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
                zIndex: 100
              }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{ bgcolor: "transparent", m: 0, p: 0, minWidth: "270px" }}
          >
            <EditDayView
              userId={selectedUser?.documentId as string}
              showProgramVacation={false}
            />
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
};

export default PresenzePage;
